exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cat-fact {\n  text-align: center;\n  cursor: pointer;\n}\n\n.cat-fact__label {\n  font-weight: bold;\n  font-size: 0.8em;\n}\n\n.cat-fact__fact {\n  font-size: 0.75em;\n  font-style: italic;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/CatFact.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/CatFact.css
// module chunks = 0